import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import urls from '../../../../../networkRequests/apiClient/endpoints'
import errorHandler from '../../../../../shared/functions/ErrorHandler/errorHandler.functions'
import { ApiErrorResponse } from '../../../../../shared/types/api.types'
import { getLockerOrdersApi } from './getLockerOrders.api'
import getLockerOrdersInitialState from './getLockerOrders.initialState'
import { GetLockerOrdersErrorResponse, GetLockerOrdersRequestPayload } from './getLockerOrders.types'

export const getLockerOrders = createAsyncThunk(
  urls.admin.getLockerOrders,
  async (payload: GetLockerOrdersRequestPayload, { rejectWithValue }) => {
    const { request, onSuccess } = payload

    try {
      const response = await getLockerOrdersApi(request)

      onSuccess && onSuccess()

      return response
    } catch (error) {
      errorHandler.handleApiError(error as ApiErrorResponse)

      return rejectWithValue(error)
    }
  }
)

const getLockerOrdersSlice = createSlice({
  name: urls.admin.getLockerOrders,
  initialState: getLockerOrdersInitialState,
  reducers: {
    resetGetLockerOrders: (state) => {
      state.loading = false
      state.error = null
      state.success = null
      state.currentRequestId = null
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getLockerOrders.pending, (state, { meta }) => {
        state.loading = true
        state.error = null
        state.success = null
        state.currentRequestId = meta.requestId
      })
      // Each status tab asks for its own orders, and switching tabs quickly leaves the earlier request
      // still out. Only the latest request's result is kept, so a slower, earlier one finishing last
      // cannot put one status's orders under another's tab.
      .addCase(getLockerOrders.fulfilled, (state, { payload, meta }) => {
        if (meta.requestId !== state.currentRequestId) return

        state.loading = false
        state.success = payload
        state.error = null
      })
      .addCase(getLockerOrders.rejected, (state, { payload, meta }) => {
        if (meta.requestId !== state.currentRequestId) return

        state.loading = false
        state.error = payload as GetLockerOrdersErrorResponse
        state.success = null
      })
  }
})

export const { actions: getLockerOrdersActions, reducer: getLockerOrdersReducer } = getLockerOrdersSlice
export const { resetGetLockerOrders } = getLockerOrdersActions
export default getLockerOrdersSlice.reducer
